import { AfterViewInit, Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { RecaptchaComponent } from 'ng-recaptcha';
import { Subject } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { UtilService } from '../../../../shared/services';

@Component({
  selector: 'app-captcha-input',
  templateUrl: './captcha-input.component.html',
  styleUrls: ['./captcha-input.component.scss']
})
export class CaptchaInputComponent implements OnInit, AfterViewInit {

  @Input() public control: FormControl | any; /**Form control of the input */
  @Input() public type: string;
  @Input() public size;
  @Input() public execute;
  @ViewChild(RecaptchaComponent, { static: true }) captchaRef: RecaptchaComponent;
  @ViewChild('captchaTemp', { static: true }) captchaTemp: ElementRef<HTMLElement>;
  @Output() dataEmit = new EventEmitter();

  challengePopup;
  siteKey;
  public captchaResolvedObs = new Subject();

  constructor(
    public util: UtilService
  ) { }

  ngOnInit() {
    this.siteKey = this.size === 'invisible' ? environment.invisible_captcha : environment.gcaptcha;
  }
  ngAfterViewInit() {
    this.checkForChallengePopup();
    if (this.execute) {
      this.executeCaptcha();
    }
  }

  public resetCaptcha() {
    this.captchaRef.reset();
  }

  public executeCaptcha() {
    this.captchaRef.execute();

  }

  /**After captch resolved */
  public resolved(captchaResponse: string) {
    // if (captchaResponse) {
    //   this.captcha.setValue(captchaResponse);
    //   this.captcha.setErrors(null);
    // } else {
    //   this.captcha.setErrors({'failed': true});
    // }
    if (captchaResponse) {
      this.control.setValue(captchaResponse);
      this.captchaResolvedObs.next(captchaResponse);
      this.dataEmit.emit(captchaResponse);
    }
  }

  /**Check for challenge popup and
   * set the position of the popup in order to
   * view correctly when its open in dialod/modal
   */
  checkForChallengePopup() {
    if (this.type?.match('dialog|sheet') && this.util.isBrowser) {
      const html: HTMLElement = this.util.doc.getElementsByTagName('html')[0];
      const allCaptchaEls = document.querySelectorAll('iframe[src^="https://www.google.com/recaptcha"][src*="bframe"]');
      this.challengePopup = Array.prototype.filter.call(allCaptchaEls, item => item.parentElement.parentElement.style.visibility === 'visible');
      if (this.challengePopup?.length) {
        if (this.type === 'sheet') {
          this.challengePopup[0].parentElement.style.top = '-60px';
        } else {
          html.style.top = '0px';
        }
      } else {
        setTimeout(() => {
          this.checkForChallengePopup();
        }, 2000);
      }
    }
  }

  @HostListener('document:click', ['$event'])
  clickout(event) {
    const captchaFrame = document.querySelector('iframe[src^="https://www.google.com/recaptcha"][src*="bframe"]');
    if (captchaFrame) {
      this.captchaResolvedObs.next(null);
    }
  }

}
